<template>
    <div id="staff-daily-income-container" class="flex flex-wrap staff-daily-income-container">
        <div class="w-2/3 left-content">
            <div class="w-full flex align-center justify-between mb-5 staff-daily-income-header">
                <div class="vx-breadcrumb" style="flex-shrink: 0">
                    <ul class="flex flex-wrap items-center">
                        <li class="inline-flex items-end">
                            <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                            <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                        </li>
                        <li class="inline-flex items-end">
                            <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Income</span>
                        </li>
                    </ul>
                </div>

                <div class="w-full flex align-center sm:flex-row flex-col justify-end">
                    <div class="flex-center date-filter">
                        <date-picker class="sm:ml-5 ml-0 sm:mb-0 mb-5 filter-year-picker" :disabled-date="disabledRange" v-model="year_filter" @change="getData" format="YYYY" type="year" :editable="false" :clearable="false" placeholder="Year" v-if="view_by.type == 'year'"></date-picker>
                        <date-picker class="sm:ml-5 ml-0 sm:mb-0 mb-5 filter-year-picker" :disabled-date="disabledRange" v-model="month_filter" @change="getData" format="MM/YYYY" type="month" :editable="false" :clearable="false" placeholder="Month" v-if="view_by.type == 'month'"></date-picker>
                        <date-picker class="sm:ml-5 ml-0 sm:mb-0 mb-5 filter-date-picker" :disabled-date="disabledRange" v-model="date_filter" @change="getData" :format="date_format_string" type="date" :editable="false" :clearable="false" placeholder="Select date" v-if="view_by.type == 'day'"></date-picker>
                    </div>
                    <div class="view-by-select sm:ml-5 ml-0 sm:mb-0 mb-5">
                        <v-select @input="changeViewType($event)" :value="view_by" label="title" :options="viewOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    </div>
                    <!-- <div class="con-input-search vs-table--search w-full sm:ml-5 ml-0 sm:mb-0 mb-5">
                        <input type="text" class="input-search vs-table--search-input w-full h-full rounded-item" v-model="keyword" @keyup="searchItem" placeholder="Staff name"/>
                        <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                    </div> -->
                    <vs-button class="gradient gradient-primary no-shadow export-btn sm:ml-5 ml-0" @click="exportData">
                        <div class="flex-center">
                            <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                            Export
                        </div>
                    </vs-button>
                </div>
            </div>

            <div class="position-relative overflow-hidden main-content">
                <vs-table :data="dailyIncomeList" v-if="dailyIncomeList">
                    <template slot="thead">
                        <vs-th class="center-title text-center">STAFF</vs-th>
                        <vs-th class="center-title text-center">INCOME</vs-th>
                        <vs-th class="center-title text-center">COMMISSION</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="item" v-for="(item, index) in data" :key="index" class="shadow-md" :class="{'active': activeItem && activeItem.user_id == item.user_id}" @click.native="activeItem = item">
                            <vs-td class="text-center">{{ item.name }}</vs-td>
                            <vs-td class="text-center">${{ item.income ? formatNumber(item.income.income) : 0 }}</vs-td>
                            <vs-td class="text-center">${{ item.income ? formatNumber(item.income.final_commission) : 0 }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>

        <div class="w-1/3 pl-5 right-content" id="staff-daily-income-right-content">
             <vx-card class="w-full no-shadow text-black">
                <div class="pb-2">
                    <h5 class="text-uppercase font-bold income-detail-title py-2 px-custom pb-2">Income Preview</h5>
                    <div v-if="activeItem">
                        <p class="font-normal text-sm px-custom mb-4">Name: {{ activeItem.name }}</p>
                        <div class="px-custom small-height-hidden" :class="{'day-view': view_by.type == 'day'}">
                            <div v-if="view_by.type == 'day'">
                                <div class="dotted-line"></div>
                                <div class="flex my-3">
                                    <div class="w-1/4">Order ID</div>
                                    <div class="w-5/12">Service</div>
                                    <div class="w-1/6">Price</div>
                                    <div class="w-1/6 text-right">Tip</div>
                                </div>

                                <div class="hidden-con">
                                    <div class="w-full h-full overflow-auto">
                                        <div class="py-2">
                                            <div v-for="(item, index) in activeItem.daily_service" :key="index">
                                                <div class="font-normal flex py-05" v-for="(service, i) in item.services" :key="i">
                                                    <div class="w-1/4">{{ i === 0 ? item.order_id : '' }}</div>
                                                    <div class="w-5/12 staff-name">{{ service.name }}</div>
                                                    <div class="w-1/6">${{ service.price }}</div>
                                                    <div class="w-1/6 text-right">{{ i === 0 ? "$" + item.tip : '' }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dotted-line"></div>
                            <div>
                                <div class="font-normal py-3" v-if="activeItem.income">
                                    <div class="flex py-05">
                                        <div class="w-1/2">Income</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.income) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Commission</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.commission) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Tip</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.tip) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Tip Charge</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.tip_credit_charge) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Card Charge</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.card_charge) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Supply Share</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.supply_share) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Cash Discount Charge</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.cash_discount_charge) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Discount Charge</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.discount_charge) }}</div>
                                    </div>
                                </div>
                                <div class="dotted-line"></div>
                                <div class="py-3" v-if="activeItem.income">
                                    <div class="flex py-05">
                                        <div class="w-1/2">Total</div>
                                        <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.final_commission) }}</div>
                                    </div>
                                    <template v-if="activeItem.income.is_fixed_amount != 1">
                                        <div class="flex py-05">
                                            <div class="w-1/2">Cash Income</div>
                                            <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.cash_income) }}</div>
                                        </div>
                                        <div class="flex py-05">
                                            <div class="w-1/2">Check Income</div>
                                            <div class="w-1/2 text-right">${{ formatNumber(activeItem.income.check_income) }}</div>
                                        </div>
                                    </template>
                                </div>

                                <div class="solid-line"></div>

                                <div class="text-center mt-3 total-income">
                                    Thank {{ activeItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-sm px-custom no-data-con" v-else>
                        No Selected Data
                    </div>
                </div>
             </vx-card>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import vSelect from 'vue-select';
import { formatDateString } from '../../helper/datetimeHelper';
export default {
    components: { DatePicker, vSelect },
    data() {
        let date_format_string = formatDateString();
        // let dailyIncomeList = [];
        let activeItem = null;
        // for(let i = 0; i < 9; i++) {
        //     dailyIncomeList.push({
        //         id: i,
        //         staff_name: "Staff " + (i + 1),
        //         income: 0,
        //         commission: 0
        //     });
        // }
        // activeItem = dailyIncomeList[0];
        return {
            keyword: "",
            // dailyIncomeList,
            activeItem,
            year_filter: new Date(),
            // date_filter: [new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1), new Date()],
            month_filter: new Date(),
            date_filter: new Date(),
            viewOptions: [
                { type: "day", title: 'Day' },
                // { type: "week", title: 'Week' },
                { type: "month", title: 'Month' },
                { type: "year", title: 'Year' }
            ],
            view_by: { type: "day", title: 'Day' },
            date_format_string,
            isOpenLoading: false,
            myWindowWidth: 0,
            subscribeSuccess: false,
            subscription: {
                topic: "/gci/{id}/staff-income/get",
                qos: 0,
            },
            isLoaded: false,
            mqttData: null,
            headerTitle: ["Staff", "Income", "Commission", "Tip","Working Hours", "Final Salary", "Tip Credit Charge", "Card Charge", "Cash bonus", "Supply Share", "Final commission", "Cash Income", "Check Income"],
            headerVal: ["name", "income", "commission", "tip","working_hours", "final_salary", "tip_credit_charge", "card_charge", "cash_bonus", "supply_share", "final_commission", "cash_income", "check_income"],
        }
    },
    computed: {
        config() {
            return this.$store.getters["auth/config"];
        },
        // staffDailyIncome() {
        //     return this.$store.getters["goPos/staffDailyIncome"];
        // },
        dailyIncomeList() {
            if(this.view_by.type == "day") {
                if(this.isLoaded) {
                    return this.$store.getters["goPos/staffDailyIncome"];
                }
                return [];
            } else {
                return this.mqttData ? this.mqttData.data : null;
            }
        },
        exportDataList() {
            if(this.dailyIncomeList) {
                return this.dailyIncomeList.map((item) => {
                    return {
                        ...item.income,
                        user_id: item.user_id,
                        name: item.name
                    }
                })
            }
            return [];
        }
    },
    watch: {
        activeItem: {
            immediate: true,
            deep: true,
            handler() {
                if(this.activeItem && this.myWindowWidth <= 1000) {
                    setTimeout(() => {
                        let elem = document.getElementById('staff-daily-income-right-content');
                        if(elem) {
                            let distance = elem.getBoundingClientRect().top + window.scrollY - 100;
                            window.scrollTo({top: distance, behavior: 'smooth'});
                        }
                    }, 50);
                }
            }
        },
        config: {
            immediate: true,
            deep: true,
            handler() {
                if(this.config && this.config.mqtt && this.subscribeSuccess == false) {
                    this.subscription = {
                        topic: `/gci/${this.config.mqtt.id}/staff-income/get`,
                        qos: 0,
                    };
                    this.doSubscribe();
                }
            }
        },
        dailyIncomeList: {
            immediate: true,
            deep: true,
            handler() {
                // console.log(this.dailyIncomeList);
                if(this.dailyIncomeList && this.dailyIncomeList.length) {
                    this.activeItem = this.dailyIncomeList[0];
                }
            }
        }
    },
    created() {
        this.getData();
        if(this.$mqttClient) {
            // this.doSubscribe();
            this.$mqttClient.on("message", (topic, content) => {
                // console.log(`Received message ${message} from topic ${topic}`);
                if(content && topic && this.config && this.config.mqtt) {
                    // console.log('topic: ', topic);
                    if (content instanceof Uint8Array) {
                        let decoder = new TextDecoder("utf-8");
                        content = JSON.parse(decoder.decode(content));
                    }
                    this.mqttData = content;
                    // console.log(content);
                    this.closeLoading();
                }
            })
        }
    },
    destroyed() {
        this.doUnSubscribe();
    },
    mounted() {
        this.$nextTick(() => {
            this.onResize();
            window.addEventListener("resize", this.onResize);
        });
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading && this.view_by.type == "day") {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: "Get data failed",
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        disabledRange(date) {
            return date > new Date();
        },
        formatNumber(value) {
            if(value) {
                return +(Math.round(value + "e+2") + "e-2");
            }
            return 0;
        },
        getData() {
            let filterObject = {
                type: this.view_by.type
            }
            if(this.view_by.type == "day") {
                filterObject.date = moment(this.date_filter).format('YYYY-MM-DD');
            }
            if(this.view_by.type == "month") {
                filterObject.month = moment(this.month_filter).format('MM');
                filterObject.year = moment(this.month_filter).format('YYYY');
            }
            if(this.view_by.type == "year") {
                filterObject.year = moment(this.year_filter).format('YYYY');
            }
            this.openLoadingInDiv();
            this.mqttData = null;
            this.isLoaded = false;
            this.$store.dispatch("goPos/GET_STAFF_DAILY_INCOME", filterObject).then(() => {
                this.isLoaded = true;
                if(this.view_by.type == "day") {
                    this.closeLoading();
                }
            }).catch((err) => {
                console.log("Error: ", err);
            })
        },
        searchItem({ target }) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            if (!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.timer = setTimeout(() => {
                this.keyword = target.value;
                this.getData();
            }, 500);
        },
        changeViewType(e) {
            this.view_by = JSON.parse(JSON.stringify(e));
            this.getData();
        },
        onResize() {
            this.myWindowWidth = window.innerWidth;
        },
        doSubscribe() {
            const { topic, qos } = this.subscription;
            this.$mqttClient.subscribe(topic, { qos }, (error, res) => {
                if (error) {
                    console.log("Subscribe to topics error", error);
                    return;
                }
                this.subscribeSuccess = true;
                console.log("Subscribe to topics res", res);
            });
        },
        doUnSubscribe() {
            const { topic } = this.subscription;
            // this.client.unsubscribe(topic, (error) => {
            this.$mqttClient.unsubscribe(topic, (error) => {
                this.subscribeSuccess = false;
                if (error) {
                    console.log("Unsubscribe error", error);
                }
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                return v[j]
            }))
        },
        exportData() {
            import('@/vendor/Export2Excel').then(excel => {
                const list = this.exportDataList
                const data = this.formatJson(this.headerVal, list)
                let date_filter = moment(this.date_filter).format("DD MMM YYYY");
                if(this.view_by.type == "month") {
                    date_filter = moment(this.month_filter).format("MMM YYYY");
                }
                if(this.view_by.type == "year") {
                    date_filter = moment(this.year_filter).format("YYYY");
                }
                let main_title = "Staff Income " + date_filter;
                let multiHeader = [main_title];
                for(let i = 1; i < this.headerTitle.length; i++) {
                    multiHeader.push("");
                }
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: "Staff Income",
                    bookType: "xlsx",
                    multiHeader: [multiHeader],
                    merges: ['A1:M1']
                })
            })
        }
    }
}
</script>